import { useState, useEffect } from "react";
import { doc, getDoc, setDoc, serverTimestamp } from "firebase/firestore";
import { onAuthStateChanged } from "firebase/auth";
import { db, auth } from "../Services/firebase-config";

export const useEventEnrollment = (eventId) => {
  const [enrollment, setEnrollment] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!eventId) {
      setEnrollment(null);
      setLoading(false);
      return;
    }

    // Wait for auth state to be resolved before checking enrollment
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (!user) {
        setEnrollment(null);
        setLoading(false);
        return;
      }

      try {
        const enrollmentRef = doc(
          db,
          "eventEnrollments",
          `${user.uid}_${eventId}`,
        );
        const snap = await getDoc(enrollmentRef);
        setEnrollment(snap.exists() ? snap.data() : null);
      } catch (err) {
        console.error("Error checking enrollment:", err);
        setEnrollment(null);
      } finally {
        setLoading(false);
      }
    });

    return () => unsubscribe();
  }, [eventId]);

  const enrollInEvent = async (id, kycData, eventTitle) => {
    if (!auth.currentUser) throw new Error("User not authenticated");

    const enrollmentRef = doc(
      db,
      "eventEnrollments",
      `${auth.currentUser.uid}_${id}`,
    );

    const enrollmentData = {
      userId: auth.currentUser.uid,
      eventId: id,
      eventTitle: eventTitle || "",
      ...kycData,
      enrolledAt: serverTimestamp(),
    };

    await setDoc(enrollmentRef, enrollmentData, { merge: true });
    setEnrollment(enrollmentData);
  };

  return { enrollment, loading, enrollInEvent };
};
